import {NgModule} from '@angular/core';
import {CmsConfig, I18nConfig, provideConfig} from '@spartacus/core';
import {
  orderApprovalTranslationChunksConfig,
  orderApprovalTranslationsDe,
  orderApprovalTranslationsEn,
} from '@spartacus/organization/order-approval/assets';
import {
  OrderApprovalRootModule,
  ORGANIZATION_ORDER_APPROVAL_FEATURE,
} from '@spartacus/organization/order-approval/root';

@NgModule({
  declarations: [],
  imports: [OrderApprovalRootModule],
  providers: [
    provideConfig({
      featureModules: {
        [ORGANIZATION_ORDER_APPROVAL_FEATURE]: {
          module: () => import('@spartacus/organization/order-approval').then((m) => m.OrderApprovalModule),
        },
      },
    } as CmsConfig),
    provideConfig({
      i18n: {
        resources: {en: orderApprovalTranslationsEn, de: orderApprovalTranslationsDe},
        chunks: orderApprovalTranslationChunksConfig,
      },
    } as I18nConfig),
  ],
})
export class OrganizationOrderApprovalFeatureModule {}
